/** Placeholder component for leaderboard adunit */
const AdLeaderboardPlaceholder = (): React.ReactElement => {
  return (
    <div
      data-testid="ad-lb-placeholder"
      className="relative flex h-[50px] w-[320px] items-center justify-center border-gray-700 bg-gray-500 text-gray-700 lg:h-[90px] lg:w-[970px]"
    >
      <span className="absolute top-1 text-5xs">ADVERTISEMENT</span>
      <span>LB</span>
    </div>
  );
};

export default AdLeaderboardPlaceholder;
